module.exports = __webpack_public_path__ + "img/remoto_temporal.5ae4c315.svg";